export default __webpack_public_path__ + "static/media/KanandaFerreira_04.07ae85d0.jpg";